module.exports = __webpack_public_path__ + "static/media/whatsapp-highlight.b2267625.svg";